import { render, staticRenderFns } from "./IssueReceiptButton.vue?vue&type=template&id=bd122400&"
import script from "./IssueReceiptButton.vue?vue&type=script&lang=ts&"
export * from "./IssueReceiptButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports